import axios from '@/plugins/axios'

export default {
  getDamAsset (damAssetId) {
    return axios
      .get(`/dam/assets/${damAssetId}`)
  }
}
